module.exports = __webpack_public_path__ + "static/img/btn6.f486a3a5.png";